class LruCache {
  constructor(maxSize) {
    this.maxSize = maxSize;
  }
  maxSize;
  map = /* @__PURE__ */ new Map();
  get(key) {
    if (!this.map.has(key)) return void 0;
    const value = this.map.get(key);
    this.map.delete(key);
    this.map.set(key, value);
    return value;
  }
  set(key, value) {
    if (this.map.has(key)) this.map.delete(key);
    this.map.set(key, value);
    if (this.map.size > this.maxSize) {
      this.map.delete(this.map.keys().next().value);
    }
  }
  has(key) {
    return this.map.has(key);
  }
  // eslint-disable-next-line tldraw/no-setter-getter
  get size() {
    return this.map.size;
  }
}
export {
  LruCache
};
//# sourceMappingURL=LruCache.mjs.map
